import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { IconButton } from '@fluentui/react/lib/Button';

import { getStyles } from './page-navigation-footer-styles';

const PageNavigationFooterUnstyled = (props) => {
  const {
    i18n,
    pageIndex,
    totalPageNumber,
    onNextPageClick,
    onPreviousPageClick,
    classes,
    allowDisable,
  } = props;

  const pageIndexContent = totalPageNumber !== 1 ?
    i18n.getString(_TL_('{{index}} of {{totalPageNumber}} pages'), { index: pageIndex + 1, totalPageNumber })
    : i18n.getString(_TL_('{{index}} of {{totalPageNumber}} page'), { index: pageIndex + 1, totalPageNumber });

  return (
    <div className={classNames(classes.pagerIcon, 'pager-navigation')} >
      <span className={classNames(classes.pageNumber, 'page-number')}>
        {pageIndexContent}
      </span>
      <IconButton
        className={classNames(classes.pageNavigationButton, 'previous-page')}
        iconProps={{ iconName: 'ChevronUp' }}
        ariaLabel={i18n.getString(_TL_('Previous page'))}
        onClick={onPreviousPageClick}
        disabled={allowDisable && pageIndex === 0}
      />
      <IconButton
        className={classNames(classes.pageNavigationButton, 'next-page')}
        iconProps={{ iconName: 'ChevronDown' }}
        ariaLabel={i18n.getString(_TL_('Next page'))}
        onClick={onNextPageClick}
        disabled={allowDisable && pageIndex === totalPageNumber - 1}
      />
    </div>
  );
};

PageNavigationFooterUnstyled.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  pageIndex: PropTypes.number.isRequired,
  totalPageNumber: PropTypes.number.isRequired,
  onNextPageClick: PropTypes.func.isRequired,
  onPreviousPageClick: PropTypes.func.isRequired,
  classes: PropTypes.shape(_.mapObject(
    getStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  allowDisable: PropTypes.bool,
};

PageNavigationFooterUnstyled.defaultProps = {
  allowDisable: true,
};

export const PageNavigationFooter = withDefaultStyles(PageNavigationFooterUnstyled, getStyles);
